import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { IcChart28, IcClose16 } from '$assets';
import { attachActions } from '$store/attach';
import { useTranslator } from '$hooks';

export const Poll: FC<{ pickerId: string }> = (props) => {
  const dispatch = useDispatch();
  const t = useTranslator();

  const handleRemove = useCallback(() => {
    dispatch(attachActions.removePoll(props.pickerId));
  }, [props.pickerId]);

  return (
    <div className="AttachPickerManager__poll">
      <div className="AttachPickerManager__poll__icon">
        <IcChart28 />
      </div>
      <div className="AttachPickerManager__poll__title">{t('new_post_attach_poll')}</div>
      <div className="AttachPickerManager__poll__cancel" onClick={handleRemove}>
        <IcClose16 />
      </div>
    </div>
  );
};
